import { Direction } from './Direction';

export const sortNumber = ({
  a,
  b,
  sortDirection,
}: {
  a: number;
  b: number;
  sortDirection?: Direction;
}) => {
  if (sortDirection === Direction.Ascending) {
    return a - b;
  } else if (sortDirection === Direction.Descending) {
    return b - a;
  } else {
    return 0;
  }
};
